<template>
  <v-row>
    <v-col cols="4">
      <v-combobox
        v-model="selectedSite"
        :items="sites"
        item-value="key"
        item-text="name"
        label="Регион"
      ></v-combobox>
    </v-col>

    <v-col cols="3">
      <v-combobox
        v-model="roles"
        :items="rolesItems"
        item-value="key"
        item-text="value"
        label="Роли"
        multiple
        outlined
        dense
      ></v-combobox>
    </v-col>
    <v-col cols="3">
      <v-switch v-model="isActive" label="Активные" color="success"></v-switch>
    </v-col>
    <!--        Pagination-->
    <v-col cols="12" class="text-lg-center">
      <v-pagination
        v-show="totalPage > 1"
        v-model="page"
        :length="totalPage"
        total-visible="10"
        @input="setPage"
      ></v-pagination>
    </v-col>
    <!--            Pagination end-->

    <ListView
      :items="users"
      :with-sites="false"
      avatar-url="avatar.url"
      items-name="users"
      title-field="name"
      edit-item="user_edit"
      description-field="region|name"
      :sortable="false"
      @remove-item="getUserList"
    >
      <template v-slot:info="{ item }">
        <div>
          <v-chip v-for="x in itemRoles(item)" :key="x" color="grey lighten-4">{{
            roleString(x)
          }}</v-chip>
        </div>
        <v-btn icon v-if="item.is_active">
          <v-icon color="green">mdi-check</v-icon>
        </v-btn>
      </template>
    </ListView>
    <v-col cols="12" class="text-lg-center">
      <v-pagination
        v-show="totalPage > 1"
        v-model="page"
        :length="totalPage"
        total-visible="10"
        @input="setPage"
      ></v-pagination>
    </v-col>
    <!--            Pagination end-->
    <v-btn
      dark
      absolute
      top
      right
      fab
      color="secondary"
      style="top: 30px"
      :to="{ name: 'user_create' }"
    >
      <v-icon dark>add</v-icon>
    </v-btn>
  </v-row>
</template>

<script>
import apiMixin from '@/mixins/api'
import userMixin from '@/mixins/user'
import ListView from '@/components/ListView'
import { HubHeader, Role, Roles, roleString } from '@/api/consts'
import { getUserList } from '@/api/user'

const PAGE_KEY = 'pageKey'
const IS_ACTIVE_KEY = 'isActiveKey'
const REGION_KEY = 'regionKey'
const ROLES_KEY = 'rolesKey'

export default {
  name: 'UserList',
  components: { ListView },
  mixins: [apiMixin, userMixin],
  data() {
    return {
      page: 1,
      totalPage: 1,
      roles: [],
      rolesItems: Roles.map((x) => {
        return { key: x, value: roleString(x) }
      }),
      users: [],
      selectedSite: '',
      region: '',
      limit: 20,
      isActive: true,
      filters: {
        region: '',
        roles: [],
        isActive: true,
      },
      lastParam: null,
      inited: false,
    }
  },
  computed: {
    params() {
      let params = {
        page: this.page,
        limit: this.limit,
        active: this.isActive,
      }
      if (this.selectedSite.key !== undefined) {
        params.region = this.selectedSite.key
      }
      if (this.roles) {
        params.roles = this.roles.map((x) => x.key).join(',')
      }
      return params
    },
  },
  watch: {
    selectedSite() {
      this.resetPage()
      localStorage.setItem(REGION_KEY, JSON.stringify(this.selectedSite))
      this.getUserList()
    },
    page() {
      this.getUserList()
    },
    isActive() {
      this.resetPage()
      localStorage.setItem(IS_ACTIVE_KEY, this.isActive)
      this.getUserList()
    },
    roles() {
      this.resetPage()
      localStorage.setItem(ROLES_KEY, JSON.stringify(this.roles))
      this.getUserList()
    },
  },

  created() {
    this.getSites()
    this.loadFilters()
    this.getUserList()
    this.inited = true
  },
  methods: {
    setPage() {
      localStorage.setItem(PAGE_KEY, this.page)
    },
    resetPage() {
      this.page = 1
      localStorage.setItem(PAGE_KEY, this.page)
    },
    loadFilters() {
      this.roles = JSON.parse(localStorage.getItem(ROLES_KEY) || '[]')
      this.selectedSite = JSON.parse(localStorage.getItem(REGION_KEY) || '{}')
      this.isActive = Boolean(localStorage.getItem(IS_ACTIVE_KEY)) || true
      this.page = Number(localStorage.getItem(PAGE_KEY)) || 1
    },
    getUserList(force) {
      if (
        this.lastParam &&
        JSON.stringify(this.lastParam) === JSON.stringify(this.params) &&
        !force
      ) {
        this.$log.debug('nothing to update', this.lastParam, this.params)
        return
      } else {
        this.$log.debug(JSON.stringify(this.lastParam), JSON.stringify(this.params))
      }
      this.lastParam = this.params
      getUserList(this.axios, this.params).then((resp) => {
        this.users = resp.data || []
        const count = resp.headers[HubHeader.TotalItems]
        this.totalPage = Math.ceil(count / this.limit)
      })
    },
    itemRoles(item) {
      return item.roles.filter((x) => {
        return x !== Role.HasFirstData && x !== Role.Registered
      })
    },
    makeParams(params) {
      const a = {
        region: this.region.key || '',
      }
      params = Object.assign({}, params, a)
      return params
    },
  },
}
</script>
